import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, token } = useAuth();

    // No console logging here. This once printed the bearer token on every
    // render — the same JWT-in-the-console disclosure risk AuthContext's
    // docstring records removing. A screen-share or a pasted bug report is one
    // step from leaking it, and it bought nothing.
    if (!isAuthenticated || !token) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default PrivateRoute;